import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IBidProcurementItem } from 'types/bids/bidProcurementItems'

export const bidProcurementItemsApi = createApi({
  reducerPath: 'bidProcurementItems',
  baseQuery,
  endpoints: (builder) => ({

    bidProcurementItems: builder.query<IBidProcurementItem[], void>({
      query: () => ({
        url: '/bid-procurement-items',
      }),
    }),

    bidProcurementItem: builder.query<IBidProcurementItem, IdParams>({
      query: ({ id }) => `/bid-procurement-items/${id}`,
    }),

    createBidProcurementItem: builder.mutation<
      IBidProcurementItem,
      Partial<IBidProcurementItem>
    >({
      query: (body) => ({
        url: '/bid-procurement-items',
        body,
        method: 'post',
      }),
    }),

    updateBidProcurementItem: builder.mutation<
      IBidProcurementItem,
      Partial<IBidProcurementItem>
    >({
      query: (body) => ({
        url: `/bid-procurement-items/${body.id}`,
        body,
        method: 'put',
      }),
    }),
    
    deleteBidProcurementItem: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/bid-procurement-items/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useBidProcurementItemQuery,
  useBidProcurementItemsQuery,
  useCreateBidProcurementItemMutation,
  useUpdateBidProcurementItemMutation,
  useDeleteBidProcurementItemMutation,
} = bidProcurementItemsApi
